import { render } from "./SearchCarts.vue?vue&type=template&id=6c2fd2c8"
import script from "./SearchCarts.vue?vue&type=script&lang=js"
export * from "./SearchCarts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__